export const ONBOARDING_PROGRESS_KEY = "onboarding_progress";
export const SELECTED_STRATEGY_KEY = "selected_strategy_id";

export function getOnboardingProgress(): string | null {
  return localStorage.getItem(ONBOARDING_PROGRESS_KEY);
}

export function setOnboardingProgress(value: string): void {
  localStorage.setItem(ONBOARDING_PROGRESS_KEY, value);
}

export function getSelectedStrategyId(): string | null {
  return localStorage.getItem(SELECTED_STRATEGY_KEY);
}

export function clearOnboardingStorage(): void {
  localStorage.removeItem(ONBOARDING_PROGRESS_KEY);
  localStorage.removeItem(SELECTED_STRATEGY_KEY);
}
